<template>
  <!--<el-row>-->
  <!--<el-col :xs="24" :sm="24" :md="24" :lg="22" :xl="20">-->
  <div v-loading="loadingApplications">
    <!--finish-status="success"-->
    <div class="minifySteps">
      <el-steps
        :active="historyActive"
        process-status="process"
        align-center
        :direction="direction"
      >
        <el-step
          v-for="step in applicationSteps"
          :key="step.stepNumber"
          :title="step.action"
          :description="step.date"
          :icon="step.icon"
          :id="step.stepNumber"
          :ref="step.action"
          @click.native="e => stepClick(e, step.stepNumber)"
        >
        </el-step>
      </el-steps>
    </div>
    <div class="maxSteps">
      <el-steps
        :active="historyActive"
        process-status="process"
        align-center
        :direction="direction"
      >
        <el-step
          v-for="step in applicationSteps"
          :key="step.stepNumber"
          :title="step.action.substring(0, 6)"
          :description="step.date"
          :icon="step.icon"
          :id="step.stepNumber"
          :ref="step.action"
          @click.native="e => stepClick(e, step.stepNumber)"
        >
        </el-step>
      </el-steps>
    </div>
    <div style="text-align: center">
      <el-button
        style="margin-top: 5px; border-radius: 5px 20px; border: 2px solid #7fa3bb;"
        @click="previousHistoryStep"
        icon="el-icon-d-arrow-left"
      ></el-button>
      <el-button
        style="margin-top: 5px; border-radius: 20px 5px; border: 2px solid #7fa3bb;"
        @click="nextHistoryStep"
        icon="el-icon-d-arrow-right"
      ></el-button>
    </div>
    <el-card class="box-card user-apply-header">
      <div slot="header" class="clearfix">
        <span
          v-if="!finalized"
          v-show="applicationTempSaved ? historyActive == 0 : false"
        >
          {{ $t('app_process') }}
          <el-tooltip placement="right">
            <div slot="content">
              {{ $t('add_info') }}
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <span
          v-if="!finalized"
          v-show="
            applicationTempSaved ? historyActive == 1 : historyActive == 0
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('fill_in_personal_data_with_caps') }}
        </span>
        <span
          v-if="!finalized"
          v-show="
          !isReappraisal && !isPostExam
          ? applicationTempSaved
            ? historyActive == 2 
            : historyActive == 1
          : false
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('fill_in_information_title_of_study') }}
        </span>
        <span
          v-if="!finalized"
          v-show="
            application.consideration
              ? applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
              : false
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('fill_in_information_title_assesed') }}
        </span>
        <span
          v-show="!finalized"
          v-if="
          !isReappraisal && !isPostExam
            ? application.consideration
              ? applicationTempSaved
                ? historyActive == 4
                : historyActive == 3
              : applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
          : applicationTempSaved
            ? historyActive == 2
            : historyActive == 1
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('upload_documents') }}
        </span>
        <span v-if="isReappraisal && isOverdue" style="color: red;">
          {{ $t('overdue_message') }}
        </span><br>
        <span
          style="padding: 3px 5px"
          v-show="application.praxeisNo !== null && finalized"
        >
          {{ $t('decision_no') }} :
          <b> {{ application.praxeisNo }} </b>
        </span>
        <span v-show='!isReappraisal && !isPostExam' style="padding: 3px 5px; color: grey">
          {{ $t('applicationType') }}: {{ $t(application.applicationType) }}
          {{
            application.correspondence
              ? $t('with_equivalence')
              : $t('without_equivalence')
          }}
          {{ $t('for') }}
          {{ $t(application.degreeType) }}
          {{
            application.degreeType === 'bachelor'
              ? application.consideration
                ? $t('with_consideration')
                : ''
              : ''
          }}
        </span>
         <span v-if='isReappraisal || isPostExam' style="padding: 3px 5px; color: grey">
          {{ $t('applicationType') }}: {{ $t(application.applicationType) }}
          {{ $t('for_app') }}
          {{ application.relevantAppl.id }}
        </span>
        <span v-if="finalized">
          <br />
          {{ $t('date_done') }}
          <b>{{ dateDone }}</b>
          {{ $t('date_received') }}
          <b>{{ dateReceived }}</b>
          <br />
          {{ $t('date_downloaded') }}
          <b>{{ dateDownloaded }}</b>
        </span>
      </div>
      <div class="text item" v-loading="saving">
        <div v-show="applicationTempSaved ? historyActive == 0 : false">
          <history-line :applicationHistory="history"></history-line>
        </div>
        <div
          v-show="
            applicationTempSaved ? historyActive == 1 : historyActive == 0
          "
        >
          <personal-details
            @personalDetailsChanged="personalDetailsEvent"
            :personalDetails="application.personalDetails"
            :applicationFinalSaved="applicationFinalSaved"
            :countries="countries"
            :checkFormPD="checkFormPD"
            @pdValidEvent="pdValidEvent"
          ></personal-details>
        </div>
        <div v-if="!isReappraisal && !isPostExam"
          v-show="
            applicationTempSaved ? historyActive == 2 : historyActive == 1
          "
        >
         <titles
            :application="application"
            @consider-other-titles="considerOtherTitlesEvent"
            :applicationFinalSaved="applicationFinalSaved"
            @titlesChanged="titlesChangedEvent"
            :isBachelor="isBachelor"
            :countries="countries"
            @countries="countriesEvent"
            :allDepartments="allDepartments"
            @titlesCorrespondenceChanged="titlesCorrespondenceChangedEvent"
            :checkFormTitles="checkFormTitles"
            @titlesValidEvent="titlesValidEvent"
          >
          </titles>
          <!-- <titles
            :application="application"
            @consider-other-titles="considerOtherTitlesEvent"
            :applicationFinalSaved="applicationFinalSaved"
            @titlesChanged="titlesChangedEvent"
            :isBachelor="isBachelor"
            :countries="countries"
            @countries="countriesEvent"
            :greekUniversityDepartments="greekUniversityDepartments"
            :greekTeiDepartments="greekTeiDepartments"
            @titlesCorrespondenceChanged="titlesCorrespondenceChangedEvent"
            :checkFormTitles="checkFormTitles"
            @titlesValidEvent="titlesValidEvent"
          >
          </titles> -->
        </div>
        <div v-if="!isReappraisal && !isPostExam"
          v-show="
            application.consideration
              ? applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
              : false
          "
        >
          <title-consideration
            :titleConsideration="application.titles.titleConsideration"
            :application="application"
            :applicationFinalSaved="applicationFinalSaved"
            :countries="countries"
            @titleConsiderationChanged="titleConsiderationEvent"
            :consideration="application.consideration"
            :checkFormTC="checkFormTC"
            @considerationValidEvent="considerationValidEvent"
          >
          </title-consideration>
        </div>
        <div :applicationFinalSaved="applicationFinalSaved"
        v-show="
          isReappraisal || isPostExam
            ? applicationTempSaved
              ? historyActive == 2
              : historyActive == 1
            : application.consideration
              ? applicationTempSaved
                ? historyActive == 4
                : historyActive == 3
            : applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
        "
        >

          <attached-documents
            :language="language"
            :applicationHistory="application.applicationHistory"
            :actApproval="actApprove"
            :precheckerCommentForUser="precheckerCommentForUser"
            :praksiDownloadedFromUser="praksiDownloadedFromUser"
            :attachedDocumentsTable="attachedDocumentsTable"
            :appId="application.id"
            :applicationFinalSaved="applicationFinalSaved"
            :neededDocsGr="neededDocsGr"
            :neededDocsEn="neededDocsEn"
            :neededDocsIds="neededDocsIds"
            :neededDocsInformation="neededDocsInformation"
            :neededDocsInformationGr="neededDocsInformationGr"
            :neededDocsInformationEng="neededDocsInformationEng"
            :neededDocsMandatory="neededDocsMandatory"
            :externalUserId="externalUserId"
            :appGeneralComment="application.userComment"
            @attachedDocumentsTableChanged="attachedDocumentsTableEvent"
            @documentsChanged="documentsChangedEvent"
            @generalCommentChanged="generalCommentChangedEvent"
            @mandatoryDocsEvent="mandatoryDocsM"
          >
          </attached-documents>
        </div>
        <div class="appStatus">
          <div>{{ $t('app_status') }}: {{ calcApplicationState }}</div>
          <!-- <div>{{ $t('app_ref') }}: {{ application.id }}</div> -->
          <div>{{ $t('reg_no') }}: {{ calcProtocol }}</div>
          <div v-if="isReappraisal">{{ $t('reappraisal_app') }}: {{ calcRelevantProtocol }}</div>
          <div v-if="isPostExam">{{ postExamRelevantAppText }}: {{ calcRelevantProtocol }}</div>
          <div v-if="isSecondReappraisal">{{ $t('first_reappraisal_app') }}: {{ application.relevantReappraisalAppl.protocol }}</div>
          <hr>
          <div>{{ $t('total_num_of_apps_are') }}: {{ usersAllApplications.length}} </div>
        </div>
      </div>
      <div style="text-align: center">
        <el-checkbox
          v-if="stagingEnv && application.applicationType === 'reappraisal' && !applicationFinalSaved && beforeFirstSave"
          style="margin-right: 20px;"
          v-model="forceOverdue"
        >
          {{ $t('force_overdue') }}
        </el-checkbox>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_tempsave') }}</div>
          <el-button
            size="mini"
            type="primary"
            round=""
            @click="tempSave"
            :disabled="applicationFinalSaved"
            >{{ $t('temp_save') }}</el-button
          >
        </el-tooltip>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_finalsave') }}</div>
          <el-button
            size="mini"
            type="warning"
            round=""
            @click="finalSave"
            :disabled="applicationFinalSaved"
            >{{ $t('final_save') }}</el-button
          >
        </el-tooltip>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_delete') }}</div>
          <el-button
            size="mini"
            type="danger"
            plain="plain"
            round=""
            @click="deleteApplication"
            :disabled="applicationFinalSaved"
            >{{ $t('delete_app') }}</el-button
          >
        </el-tooltip>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_retract') }}</div>
          <el-button
            size="mini"
            type="danger"
            plain="plain"
            round=""
            @click="retractApplication"
            :disabled="!(applicationFinalSaved && inPrecheckersQueue)"
            >{{ $t('retract_app') }}</el-button
          >
        </el-tooltip>
      </div>
    </el-card>
  </div>
  <!--</el-col>-->
  <!--</el-row>-->
</template>

<script>
import axios from 'axios'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import config from '../config.js'
import sharedMethods from './common/sharedMethods.js'
// import { DataSet } from "vue2vis";

const decisionReceiptDocs = [20, 1008, 1010]

export default {
  name: 'userApply',
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  beforeRouteEnter(to, from, next) {
    if (to.fullPath === '/userApply' && from.fullPath === '/') {
      next(vm => {
        let obj = JSON.parse(sessionStorage.getItem('workingApplication'))
        this.isOverdue = obj.overdue
        vm.$emit('workingApplication', obj)
      })
    }
    next()
  },
  mounted: function() {
    this.application = JSON.parse(sessionStorage.getItem('workingApplication'))
    this.localHistory = this.history
    if (JSON.parse(sessionStorage.getItem('refreshed'))) {
      this.$notify.warning({
        title: this.$t('warning'),
        message: this.$t('refresh_notallowed'),
        duration: 0,
        offset: 100,
      })
      let app = JSON.parse(sessionStorage.getItem('workingApplication'))
      this.isOverdue = app.overdue
      this.$emit('workingApplication', app)
      this.$emit(
        'neededDocsGr',
        JSON.parse(sessionStorage.getItem('neededDocsGr'))
      )
      this.$emit(
        'neededDocsEn',
        JSON.parse(sessionStorage.getItem('neededDocsEn'))
      )
      this.$emit(
        'neededDocsIds',
        JSON.parse(sessionStorage.getItem('neededDocsIds'))
      )
      this.$emit(
        'neededDocsInformation',
        JSON.parse(sessionStorage.getItem('neededDocsInformation'))
      )
      this.$emit(
        'neededDocsInformationGr',
        JSON.parse(sessionStorage.getItem('neededDocsInformationGr'))
      )
      this.$emit(
        'neededDocsInformationEng',
        JSON.parse(sessionStorage.getItem('neededDocsInformationEng'))
      )
      this.$emit(
        'neededDocsMandatory',
        JSON.parse(sessionStorage.getItem('neededDocsMandatory'))
      )
      this.$emit(
        'userLoggedIn',
        JSON.parse(sessionStorage.getItem('currentUser'))
      )
      this.$emit(
        'externalUserId',
        JSON.parse(sessionStorage.getItem('externalUserId'))
      )
      this.$emit(
        'usersAllApplications',
        JSON.parse(sessionStorage.getItem('usersAllApplications'))
      )
      this.$emit('countries', JSON.parse(sessionStorage.getItem('countries')))
      sessionStorage.setItem('refreshed', false)
    }
//     this.allDepartments =
// [
// 	{
// 		"departmentInstitution": "ΑΚΑΔΗΜΙΕΣ ΕΜΠΟΡΙΚΟΥ ΝΑΥΤΙΚΟΥ",
// 		"departmentID": 817,
// 		"departmentName": "ΣΧΟΛΗ ΠΛΟΙΑΡΧΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΚΑΔΗΜΙΕΣ ΕΜΠΟΡΙΚΟΥ ΝΑΥΤΙΚΟΥ",
// 		"departmentID": 818,
// 		"departmentName": "ΣΧΟΛΗ ΜΗΧΑΝΙΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΕΚΚΛΗΣΙΑΣΤΙΚΗ ΑΚΑΔΗΜΙΑ ΑΘΗΝΩΝ",
// 		"departmentID": 413,
// 		"departmentName": "ΠΡΟΓΡΑΜΜΑ ΙΕΡΑΤΙΚΩΝ ΣΠΟΥΔΩΝ ΑΘΗΝΑΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΚΑΛΩΝ ΤΕΧΝΩΝ",
// 		"departmentID": 384,
// 		"departmentName": "ΘΕΩΡΙΑΣ ΚΑΙ ΙΣΤΟΡΙΑΣ ΤΗΣ ΤΕΧΝΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΚΑΛΩΝ ΤΕΧΝΩΝ",
// 		"departmentID": "1674",
// 		"departmentName": "ΕΙΚΑΣΤΙΚΩΝ ΤΕΧΝΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΚΑΛΩΝ ΤΕΧΝΩΝ",
// 		"departmentID": "1675",
// 		"departmentName": "ΘΕΩΡΙΑΣ ΚΑΙ ΙΣΤΟΡΙΑΣ ΤΗΣ ΤΕΧΝΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ",
// 		"departmentID": 477,
// 		"departmentName": "ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ "
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ",
// 		"departmentID": 497,
// 		"departmentName": "ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΩΝ  ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ - ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ",
// 		"departmentID": 507,
// 		"departmentName": "ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ- ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ",
// 		"departmentID": 776,
// 		"departmentName": "ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΕΡΕΣ ΣΧΟΛΕΣ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (Α.Σ.Τ.Ε.)",
// 		"departmentID": 613,
// 		"departmentName": "ΑΝΩΤΕΡΗ ΣΧΟΛΗ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΡΟΔΟΥ (ΑΣΤΕΡ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΝΩΤΕΡΕΣ ΣΧΟΛΕΣ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (Α.Σ.Τ.Ε.)",
// 		"departmentID": 614,
// 		"departmentName": "ΑΝΩΤΕΡΗ ΣΧΟΛΗ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΚΡΗΤΗΣ (ΑΣΤΕΚ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 103,
// 		"departmentName": "ΘΕΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 107,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΘΕΟΛΟΓΙΑΣ ΚΑΙ ΧΡΙΣΤΙΑΝΙΚΟΥ ΠΟΛΙΤΙΣΜΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 111,
// 		"departmentName": "ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 112,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 119,
// 		"departmentName": "ΝΟΜΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 120,
// 		"departmentName": "ΦΙΛΟΣΟΦΙΑΣ ΚΑΙ ΠΑΙΔΑΓΩΓΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 129,
// 		"departmentName": "ΑΓΓΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 133,
// 		"departmentName": "ΓΑΛΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 134,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΠΡΟΣΧΟΛΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΕΚΠΑΙΔΕΥΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 137,
// 		"departmentName": "ΓΕΡΜΑΝΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 139,
// 		"departmentName": "ΙΤΑΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 140,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 147,
// 		"departmentName": "ΔΗΜΟΣΙΟΓΡΑΦΙΑΣ ΚΑΙ ΜΕΣΩΝ ΜΑΖΙΚΗΣ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 163,
// 		"departmentName": "ΚΙΝΗΜΑΤΟΓΡΑΦΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 168,
// 		"departmentName": "ΘΕΑΤΡΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 172,
// 		"departmentName": "ΨΥΧΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 203,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 211,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 219,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 227,
// 		"departmentName": "ΑΓΡΟΝΟΜΩΝ ΚΑΙ ΤΟΠΟΓΡΑΦΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 233,
// 		"departmentName": "ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 237,
// 		"departmentName": "ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 245,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 255,
// 		"departmentName": "ΦΥΣΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 265,
// 		"departmentName": "ΧΗΜΕΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 273,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΑΠΘ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 275,
// 		"departmentName": "ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΦΥΣΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 279,
// 		"departmentName": "ΒΙΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 285,
// 		"departmentName": "ΓΕΩΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 291,
// 		"departmentName": "ΦΑΡΜΑΚΕΥΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 297,
// 		"departmentName": "ΙΑΤΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 305,
// 		"departmentName": "ΟΔΟΝΤΙΑΤΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 307,
// 		"departmentName": "ΚΤΗΝΙΑΤΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 311,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΑΠΘ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 338,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 357,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 363,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΧΩΡΟΤΑΞΙΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 402,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 403,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 406,
// 		"departmentName": "ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
// 		"departmentID": 780,
// 		"departmentName": "ΘΕΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ) - ΜΟΥΣΟΥΛΜΑΝΙΚΩΝ ΣΠΟΥΔΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΑΣΤΥΝΟΜΙΚΕΣ ΣΧΟΛΕΣ",
// 		"departmentID": 869,
// 		"departmentName": "ΑΞΙΩΜΑΤΙΚΩΝ ΕΛΛΗΝΙΚΗΣ ΑΣΤΥΝΟΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΣΤΥΝΟΜΙΚΕΣ ΣΧΟΛΕΣ",
// 		"departmentID": 870,
// 		"departmentName": "ΑΣΤΥΦΥΛΑΚΩΝ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΑΣΤΥΝΟΜΙΚΕΣ ΣΧΟΛΕΣ",
// 		"departmentID": 872,
// 		"departmentName": "ΑΞΙΩΜΑΤΙΚΩΝ ΕΛΛΗΝΙΚΗΣ ΑΣΤΥΝΟΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΑΣΤΥΝΟΜΙΚΟΥΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 323,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΦΥΤΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 324,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΖΩΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 325,
// 		"departmentName": "ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 326,
// 		"departmentName": "ΑΓΡΟΤΙΚΗΣ ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 327,
// 		"departmentName": "ΑΞΙΟΠΟΙΗΣΗΣ ΦΥΣΙΚΩΝ ΠΟΡΩΝ ΚΑΙ ΓΕΩΡΓΙΚΗΣ ΜΗΧΑΝΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 328,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΤΡΟΦΗΣ ΤΟΥ ΑΝΘΡΩΠΟΥ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1061,
// 		"departmentName": "ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΦΥΣΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΚΑΡΠΕΝΗΣΙ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1063,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΓΕΩΡΓΙΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΕΦΟΔΙΑΣΜΟΥ (ΘΗΒΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1064,
// 		"departmentName": "ΠΕΡΙΦΕΡΕΙΑΚΗΣ ΚΑΙ ΟΙΚΟΝΟΜΙΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΑΜΦΙΣΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 97,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 106,
// 		"departmentName": "ΕΛΛΗΝΙΚΗΣ ΦΙΛΟΛΟΓΙΑΣ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 108,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ ΚΑΙ ΕΘΝΟΛΟΓΙΑΣ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 121,
// 		"departmentName": "ΝΟΜΙΚΗΣ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 142,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 160,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΗΛΙΚΙΑ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 186,
// 		"departmentName": "ΓΛΩΣΣΑΣ, ΦΙΛΟΛΟΓΙΑΣ ΚΑΙ ΠΟΛΙΤΙΣΜΟΥ ΠΑΡΕΥΞΕΙΝΙΩΝ ΧΩΡΩΝ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 207,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΞΑΝΘΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 212,
// 		"departmentName": "ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΠΕΡΙΒΑΛΛΟΝΤΟΣ ΚΑΙ ΦΥΣΙΚΩΝ ΠΟΡΩΝ (ΟΡΕΣΤΙΑΔΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 223,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΞΑΝΘΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 224,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΞΑΝΘΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 234,
// 		"departmentName": "ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΞΑΝΘΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 290,
// 		"departmentName": "ΜΟΡΙΑΚΗΣ ΒΙΟΛΟΓΙΑΣ ΚΑΙ ΓΕΝΕΤΙΚΗΣ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 302,
// 		"departmentName": "ΙΑΤΡΙΚΗΣ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 353,
// 		"departmentName": "ΑΓΡΟΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΟΡΕΣΤΙΑΔΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 373,
// 		"departmentName": "ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 404,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 476,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΞΑΝΘΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 1301,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ",
// 		"departmentID": 1302,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΚΟΜΟΤΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1601,
// 		"departmentName": "ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1602,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1603,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΦΟΔΙΑΣΤΙΚΗΣ ΑΛΥΣΙΔΑΣ (ΚΑΤΕΡΙΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1604,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΚΑΒΑΛΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1605,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΟΡΓΑΝΙΣΜΩΝ, ΜΑΡΚΕΤΙΝΓΚ ΚΑΙ ΤΟΥΡΙΣΜΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1606,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΠΛΗΡΟΦΟΡΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1607,
// 		"departmentName": "ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΚΑΒΑΛΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1609,
// 		"departmentName": "ΒΙΒΛΙΟΘΗΚΟΝΟΜΙΑΣ, ΑΡΧΕΙΟΝΟΜΙΑΣ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΠΛΗΡΟΦΟΡΗΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1610,
// 		"departmentName": "ΑΓΩΓΗΣ ΚΑΙ ΦΡΟΝΤΙΔΑΣ ΣΤΗΝ ΠΡΩΙΜΗ ΠΑΙΔΙΚΗ ΗΛΙΚΙΑ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1613,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1614,
// 		"departmentName": "ΜΑΙΕΥΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1615,
// 		"departmentName": "ΒΙΟΪΑΤΡΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1616,
// 		"departmentName": "ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1617,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΔΙΔΥΜΟΤΕΙΧΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1618,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1619,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1620,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΤΟΠΟΓΡΑΦΙΑΣ ΚΑΙ ΓΕΩΠΛΗΡΟΦΟΡΙΚΗΣ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1621,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1622,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ, ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1623,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1624,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1625,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1626,
// 		"departmentName": "ΕΣΩΤΕΡΙΚΗΣ ΑΡΧΙΤΕΚΤΟΝΙΚΗΣ (ΣΕΡΡΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1627,
// 		"departmentName": "ΔΗΜΙΟΥΡΓΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΕΝΔΥΣΗΣ (ΚΙΛΚΙΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1628,
// 		"departmentName": "ΦΥΣΙΚΗΣ (ΚΑΒΑΛΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1629,
// 		"departmentName": "ΧΗΜΕΙΑΣ (ΚΑΒΑΛΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1630,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ (ΚΑΒΑΛΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1632,
// 		"departmentName": "ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΦΥΣΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΔΡΑΜΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1633,
// 		"departmentName": "ΑΓΡΟΤΙΚΗΣ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ ΚΑΙ ΟΙΝΟΛΟΓΙΑΣ (ΔΡΑΜΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1634,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΔΙ.ΠΑ.Ε."
// 	},
// 	{
// 		"departmentInstitution": "ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ",
// 		"departmentID": 1635,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 101,
// 		"departmentName": "ΘΕΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 105,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΘΕΟΛΟΓΙΑΣ ΚΑΙ ΘΡΗΣΚΕΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 109,
// 		"departmentName": "ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 110,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 117,
// 		"departmentName": "ΝΟΜΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 123,
// 		"departmentName": "ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΔΗΜΟΣΙΑΣ ΔΙΟΙΚΗΣΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 127,
// 		"departmentName": "ΑΓΓΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 128,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 131,
// 		"departmentName": "ΓΑΛΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 135,
// 		"departmentName": "ΓΕΡΜΑΝΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 146,
// 		"departmentName": "ΘΕΑΤΡΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 148,
// 		"departmentName": "ΕΠΙΚΟΙΝΩΝΙΑΣ ΚΑΙ ΜΕΣΩΝ ΜΑΖΙΚΗΣ ΕΝΗΜΕΡΩΣΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 154,
// 		"departmentName": "ΕΚΠΑΙΔΕΥΣΗΣ ΚΑΙ ΑΓΩΓΗΣ ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΗΛΙΚΙΑ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 171,
// 		"departmentName": "ΨΥΧΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΕΚΠΑ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 173,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ ΚΑΙ ΦΙΛΟΣΟΦΙΑΣ ΤΗΣ ΕΠΙΣΤΗΜΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 182,
// 		"departmentName": "ΙΤΑΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 183,
// 		"departmentName": "ΙΣΠΑΝΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 188,
// 		"departmentName": "ΤΟΥΡΚΙΚΩΝ ΣΠΟΥΔΩΝ ΚΑΙ ΣΥΓΧΡΟΝΩΝ ΑΣΙΑΤΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 192,
// 		"departmentName": "ΡΩΣΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ ΚΑΙ ΣΛΑΒΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ) – ΡΩΣΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 243,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 253,
// 		"departmentName": "ΦΥΣΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 263,
// 		"departmentName": "ΧΗΜΕΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 277,
// 		"departmentName": "ΒΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 283,
// 		"departmentName": "ΓΕΩΛΟΓΙΑΣ ΚΑΙ ΓΕΩΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 289,
// 		"departmentName": "ΦΑΡΜΑΚΕΥΤΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 295,
// 		"departmentName": "ΙΑΤΡΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 303,
// 		"departmentName": "ΟΔΟΝΤΙΑΤΡΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 306,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 309,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 330,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 401,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 408,
// 		"departmentName": "ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1001,
// 		"departmentName": "ΑΓΡΟΤΙΚΗΣ ΑΝΑΠTΥΞΗΣ, ΑΓΡΟΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΦΥΣΙΚΩΝ ΠΟΡΩΝ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1002,
// 		"departmentName": "ΑΕΡΟΔΙΑΣΤΗΜΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1004,
// 		"departmentName": "ΔΙΑΧΕΙΡΙΣΗΣ ΛΙΜΕΝΩΝ ΚΑΙ ΝΑΥΤΙΛΙΑΣ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1005,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΟΡΓΑΝΙΣΜΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1006,
// 		"departmentName": "ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΕΚΠΑ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1007,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1008,
// 		"departmentName": "ΤΕΧΝΟΛΟΓΙΩΝ ΨΗΦΙΑΚΗΣ ΒΙΟΜΗΧΑΝΙΑΣ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1010,
// 		"departmentName": "ΦΙΛΟΣΟΦΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 1011,
// 		"departmentName": "ΨΗΦΙΑΚΩΝ ΤΕΧΝΩΝ ΚΑΙ ΚΙΝΗΜΑΤΟΓΡΑΦΟΥ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 201,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 209,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 217,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 225,
// 		"departmentName": "ΑΓΡΟΝΟΜΩΝ ΚΑΙ ΤΟΠΟΓΡΑΦΩΝ ΜΗΧΑΝΙΚΩΝ - ΜΗΧΑΝΙΚΩΝ ΓΕΩΠΛΗΡΟΦΟΡΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 229,
// 		"departmentName": "ΝΑΥΠΗΓΩΝ ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 231,
// 		"departmentName": "ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 235,
// 		"departmentName": "ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 241,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΜΕΤΑΛΛΕΙΩΝ ΜΕΤΑΛΛΟΥΡΓΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ",
// 		"departmentID": 246,
// 		"departmentName": "ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ ΚΑΙ ΦΥΣΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1665",
// 		"departmentName": "ΔΗΜΟΣΙΑ ΔΙΟΙΚΗΣΗ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1666",
// 		"departmentName": "ΔΙΟΙΚΗΣΗ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΟΡΓΑΝΙΣΜΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1667",
// 		"departmentName": "ΔΙΟΙΚΗΣΗ ΤΟΥΡΙΣΜΟΥ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1668",
// 		"departmentName": "ΙΣΠΑΝΙΚΗ ΓΛΩΣΣΑ ΚΑΙ ΠΟΛΙΤΙΣΜΟΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1669",
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1670",
// 		"departmentName": "ΣΠΟΥΔΕΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΗΣ ΓΡΑΦΗΣ, ΠΡΑΚΤΙΚΗΣ ΚΑΙ ΕΡΕΥΝΑΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1671",
// 		"departmentName": "ΣΠΟΥΔΕΣ ΣΤΙΣ ΦΥΣΙΚΕΣ ΕΠΙΣΤΗΜΕΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1672",
// 		"departmentName": "ΣΠΟΥΔΕΣ ΣΤΟΝ ΕΛΛΗΝΙΚΟ ΠΟΛΙΤΙΣΜΟ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": "1673",
// 		"departmentName": "ΣΠΟΥΔΕΣ ΣΤΟΝ ΕΥΡΩΠΑΪΚΟ ΠΟΛΙΤΙΣΜΟ"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1651,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1652,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1653,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΟΛΟΓΙΑΣ (ΣΗΤΕΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1654,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1655,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΤΟΥΡΙΣΜΟΥ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1656,
// 		"departmentName": "ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΑΓΙΟΣ ΝΙΚΟΛΑΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1657,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1659,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1660,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1662,
// 		"departmentName": "ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΧΑΝΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1664,
// 		"departmentName": "ΜΟΥΣΙΚΗΣ ΤΕΧΝΟΛΟΓΙΑΣ ΚΑΙ ΑΚΟΥΣΤΙΚΗΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 145,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ (ΚΕΡΚΥΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 342,
// 		"departmentName": "ΑΡΧΕΙΟΝΟΜΙΑΣ, ΒΙΒΛΙΟΘΗΚΟΝΟΜΙΑΣ ΚΑΙ ΜΟΥΣΕΙΟΛΟΓΙΑΣ (ΚΕΡΚΥΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 366,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ (ΚΕΡΚΥΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 367,
// 		"departmentName": "ΤΕΧΝΩΝ ΗΧΟΥ ΚΑΙ ΕΙΚΟΝΑΣ (ΚΕΡΚΥΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 385,
// 		"departmentName": "ΞΕΝΩΝ ΓΛΩΣΣΩΝ ΜΕΤΑΦΡΑΣΗΣ ΚΑΙ ΔΙΕΡΜΗΝΕΙΑΣ (ΚΕΡΚΥΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 407,
// 		"departmentName": "ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΚΕΡΚΥΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1452,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΑΡΓΟΣΤΟΛΙ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1453,
// 		"departmentName": "ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΖΑΚΥΝΘΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1455,
// 		"departmentName": "ΤΟΥΡΙΣΜΟΥ (ΚΕΡΚΥΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 1456,
// 		"departmentName": "ΨΗΦΙΑΚΩΝ ΜΕΣΩΝ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΑΡΓΟΣΤΟΛΙ)"
// 	},
// 	{
// 		"departmentInstitution": "ΛΙΜΕΝΙΚΟ ΣΩΜΑ - ΕΛΛΗΝΙΚΗ ΑΚΤΟΦΥΛΑΚΗ",
// 		"departmentID": 881,
// 		"departmentName": "ΣΧΟΛΗ ΔΟΚΙΜΩΝ ΣΗΜΑΙΟΦΟΡΩΝ ΛΙΜΕΝΙΚΟΥ ΣΩΜΑΤΟΣ - ΕΛΛΗΝΙΚΗΣ ΑΚΤΟΦΥΛΑΚΗΣ (Σ.Δ.Σ.Λ.Σ. - ΕΛ.ΑΚΤ.) (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΛΙΜΕΝΙΚΟ ΣΩΜΑ - ΕΛΛΗΝΙΚΗ ΑΚΤΟΦΥΛΑΚΗ",
// 		"departmentID": 882,
// 		"departmentName": "ΣΧΟΛΗ ΔΟΚΙΜΩΝ ΛΙΜΕΝΟΦΥΛΑΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΛΙΜΕΝΙΚΟ ΣΩΜΑ - ΕΛΛΗΝΙΚΗ ΑΚΤΟΦΥΛΑΚΗ",
// 		"departmentID": 883,
// 		"departmentName": "ΣΧΟΛΗ ΔΟΚΙΜΩΝ ΣΗΜΑΙΟΦΟΡΩΝ ΛΙΜΕΝΙΚΟΥ ΣΩΜΑΤΟΣ - ΕΛΛΗΝΙΚΗΣ ΑΚΤΟΦΥΛΑΚΗΣ (Σ.Δ.Σ.Λ.Σ. - ΕΛ.ΑΚΤ.) (ΜΟΝΟ ΓΙΑ ΕΝ ΕΝΕΡΓΕΙΑ ΣΤΕΛΕΧΗ ΛΣ-ΕΛ.ΑΚΤ.)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 150,
// 		"departmentName": "ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 240,
// 		"departmentName": "ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 312,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 313,
// 		"departmentName": "ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 314,
// 		"departmentName": "ΜΑΡΚΕΤΙΝΓΚ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 329,
// 		"departmentName": "ΣΤΑΤΙΣΤΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 333,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ",
// 		"departmentID": 347,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 155,
// 		"departmentName": "ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ ΚΑΙ ΤΡΑΠΕΖΙΚΗΣ ΔΙΟΙΚΗΤΙΚΗΣ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 157,
// 		"departmentName": "ΝΑΥΤΙΛΙΑΚΩΝ ΣΠΟΥΔΩΝ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 262,
// 		"departmentName": "ΨΗΦΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 315,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 316,
// 		"departmentName": "ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 318,
// 		"departmentName": "ΣΤΑΤΙΣΤΙΚΗΣ ΚΑΙ ΑΣΦΑΛΙΣΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 336,
// 		"departmentName": "ΒΙΟΜΗΧΑΝΙΚΗΣ ΔΙΟΙΚΗΣΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 339,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 355,
// 		"departmentName": "ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΣΠΟΥΔΩΝ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ",
// 		"departmentID": 375,
// 		"departmentName": "ΤΟΥΡΙΣΤΙΚΩΝ ΣΠΟΥΔΩΝ (ΠΕΙΡΑΙΑΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 143,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΡΟΔΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 162,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΠΡΟΣΧΟΛΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ (ΡΟΔΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 167,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΑΝΘΡΩΠΟΛΟΓΙΑΣ ΚΑΙ ΙΣΤΟΡΙΑΣ (ΜΥΤΙΛΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 180,
// 		"departmentName": "ΝΑΥΤΙΛΙΑΣ ΚΑΙ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ (ΧΙΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 181,
// 		"departmentName": "ΜΕΣΟΓΕΙΑΚΩΝ ΣΠΟΥΔΩΝ (ΡΟΔΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 218,
// 		"departmentName": "ΣΤΑΤΙΣΤΙΚΗΣ ΚΑΙ ΑΝΑΛΟΓΙΣΤΙΚΩΝ-ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΜΑΘΗΜΑΤΙΚΩΝ (ΣΑΜΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 222,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΧΙΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 238,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΣΧΕΔΙΑΣΗΣ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ (ΣΥΡΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 252,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ (ΣΑΜΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 276,
// 		"departmentName": "ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΜΥΤΙΛΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 310,
// 		"departmentName": "ΓΕΩΓΡΑΦΙΑΣ (ΜΥΤΙΛΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 320,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΧΙΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 344,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΑΚΩΝ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΣΑΜΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 348,
// 		"departmentName": "ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΜΥΤΙΛΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 354,
// 		"departmentName": "ΠΟΛΙΤΙΣΜΙΚΗΣ ΤΕΧΝΟΛΟΓΙΑΣ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΜΥΤΙΛΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 372,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΤΡΟΦΗΣ (ΛΗΜΝΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 612,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΤΟΥΡΙΣΜΟΥ (ΧΙΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ",
// 		"departmentID": 1391,
// 		"departmentName": "ΩΚΕΑΝΟΓΡΑΦΙΑΣ ΚΑΙ ΘΑΛΑΣΣΙΩΝ ΒΙΟΕΠΙΣΤΗΜΩΝ (ΜΥΤΙΛΗΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 387,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 388,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΒΙΟΪΑΤΡΙΚΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 389,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΒΙΟΜΗΧΑΝΙΚΗΣ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΠΑΡΑΓΩΓΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 390,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΥΠΟΛΟΓΙΣΤΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 391,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΤΟΠΟΓΡΑΦΙΑΣ ΚΑΙ ΓΕΩΠΛΗΡΟΦΟΡΙΚΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 392,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 393,
// 		"departmentName": "ΝΑΥΠΗΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 394,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 668,
// 		"departmentName": "ΑΡΧΕΙΟΝΟΜΙΑΣ, ΒΙΒΛΙΟΘΗΚΟΝΟΜΙΑΣ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΠΛΗΡΟΦΟΡΗΣΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 669,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 670,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΤΟΥΡΙΣΜΟΥ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 671,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 672,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 673,
// 		"departmentName": "ΑΓΩΓΗΣ ΚΑΙ ΦΡΟΝΤΙΔΑΣ ΣΤΗΝ ΠΡΩΙΜΗ ΠΑΙΔΙΚΗ ΗΛΙΚΙΑ (ΙΛΙΟΝ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 674,
// 		"departmentName": "ΓΡΑΦΙΣΤΙΚΗΣ ΚΑΙ ΟΠΤΙΚΗΣ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 675,
// 		"departmentName": "ΕΣΩΤΕΡΙΚΗΣ ΑΡΧΙΤΕΚΤΟΝΙΚΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 676,
// 		"departmentName": "ΣΥΝΤΗΡΗΣΗΣ ΑΡΧΑΙΟΤΗΤΩΝ ΚΑΙ ΕΡΓΩΝ ΤΕΧΝΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 677,
// 		"departmentName": "ΦΩΤΟΓΡΑΦΙΑΣ ΚΑΙ ΟΠΤΙΚΟΑΚΟΥΣΤΙΚΩΝ ΤΕΧΝΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 678,
// 		"departmentName": "ΒΙΟΪΑΤΡΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 679,
// 		"departmentName": "ΔΗΜΟΣΙΑΣ ΚΑΙ ΚΟΙΝΟΤΙΚΗΣ ΥΓΕΙΑΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 680,
// 		"departmentName": "ΕΡΓΟΘΕΡΑΠΕΙΑΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 681,
// 		"departmentName": "ΜΑΙΕΥΤΙΚΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 682,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 683,
// 		"departmentName": "ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 684,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ",
// 		"departmentID": 685,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΟΙΝΟΥ, ΑΜΠΕΛΟΥ ΚΑΙ ΠΟΤΩΝ (ΑΙΓΑΛΕΩ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 210,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 334,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΦΛΩΡΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 341,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΝΗΠΙΑΓΩΓΩΝ (ΦΛΩΡΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1541,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΟΡΥΚΤΩΝ ΠΟΡΩΝ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1542,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΣΧΕΔΙΑΣΗΣ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1544,
// 		"departmentName": "ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1545,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1546,
// 		"departmentName": "ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΓΡΕΒΕΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1547,
// 		"departmentName": "ΣΤΑΤΙΣΤΙΚΗΣ ΚΑΙ ΑΣΦΑΛΙΣΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΓΡΕΒΕΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1548,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΚΑΣΤΟΡΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1549,
// 		"departmentName": "ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΣΠΟΥΔΩΝ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1550,
// 		"departmentName": "ΨΥΧΟΛΟΓΙΑΣ (ΦΛΩΡΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1551,
// 		"departmentName": "ΕΠΙΚΟΙΝΩΝΙΑΣ ΚΑΙ ΨΗΦΙΑΚΩΝ ΜΕΣΩΝ (ΚΑΣΤΟΡΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1552,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ (ΦΛΩΡΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1553,
// 		"departmentName": "ΜΑΙΕΥΤΙΚΗΣ (ΠΤΟΛΕΜΑΪΔΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1554,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ (ΚΑΣΤΟΡΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1555,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ (ΚΑΣΤΟΡΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1558,
// 		"departmentName": "ΕΡΓΟΘΕΡΑΠΕΙΑΣ (ΠΤΟΛΕΜΑΪΔΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1563,
// 		"departmentName": "ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1564,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΚΟΖΑΝΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 99,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΛΑΜΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 164,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 166,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΠΡΟΣΧΟΛΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 177,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ, ΑΡΧΑΙΟΛΟΓΙΑΣ ΚΑΙ ΚΟΙΝΩΝΙΚΗΣ ΑΝΘΡΩΠΟΛΟΓΙΑΣ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 178,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΕΙΔΙΚΗΣ ΑΓΩΓΗΣ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 208,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 220,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 228,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΧΩΡΟΤΑΞΙΑΣ, ΠΟΛΕΟΔΟΜΙΑΣ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 236,
// 		"departmentName": "ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 274,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ, ΦΥΤΙΚΗΣ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΑΓΡΟΤΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 284,
// 		"departmentName": "ΒΙΟΧΗΜΕΙΑΣ ΚΑΙ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 300,
// 		"departmentName": "ΙΑΤΡΙΚΗΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 308,
// 		"departmentName": "ΚΤΗΝΙΑΤΡΙΚΗΣ (ΚΑΡΔΙΤΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 332,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 350,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 360,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ, ΙΧΘΥΟΛΟΓΙΑΣ ΚΑΙ ΥΔΑΤΙΝΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 369,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ ΜΕ ΕΦΑΡΜΟΓΕΣ ΣΤΗ ΒΙΟΪΑΤΡΙΚΗ (ΛΑΜΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 405,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΤΡΙΚΑΛΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1422,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ - ΑΓΡΟΤΕΧΝΟΛΟΓΙΑΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1423,
// 		"departmentName": "ΓΛΩΣΣΙΚΩΝ ΚΑΙ ΔΙΑΠΟΛΙΤΙΣΜΙΚΩΝ ΣΠΟΥΔΩΝ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1424,
// 		"departmentName": "ΔΑΣΟΛΟΓΙΑΣ, ΕΠΙΣΤΗΜΩΝ ΞΥΛΟΥ ΚΑΙ ΣΧΕΔΙΑΣΜΟΥ (ΚΑΡΔΙΤΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1425,
// 		"departmentName": "ΔΗΜΟΣΙΑΣ ΚΑΙ ΕΝΙΑΙΑΣ ΥΓΕΙΑΣ (ΚΑΡΔΙΤΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1426,
// 		"departmentName": "ΔΙΑΙΤΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΤΡΟΦΟΛΟΓΙΑΣ (ΤΡΙΚΑΛΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1427,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1428,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΖΩΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1429,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΤΡΟΦΗΣ (ΚΑΡΔΙΤΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1430,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1432,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ (ΛΑΜΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1433,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1434,
// 		"departmentName": "ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1435,
// 		"departmentName": "ΠΟΛΙΤΙΣΜΟΥ ΚΑΙ ΔΗΜΙΟΥΡΓΙΚΩΝ ΜΕΣΩΝ ΚΑΙ ΒΙΟΜΗΧΑΝΙΩΝ (ΒΟΛΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1436,
// 		"departmentName": "ΣΥΣΤΗΜΑΤΩΝ ΕΝΕΡΓΕΙΑΣ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1437,
// 		"departmentName": "ΦΥΣΙΚΗΣ (ΛΑΜΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1438,
// 		"departmentName": "ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΛΑΜΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ",
// 		"departmentID": 1439,
// 		"departmentName": "ΨΗΦΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΛΑΡΙΣΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 113,
// 		"departmentName": "ΦΙΛΟΛΟΓΙΑΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 114,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 122,
// 		"departmentName": "ΦΙΛΟΣΟΦΙΑΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 130,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 156,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΝΗΠΙΑΓΩΓΩΝ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 249,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 259,
// 		"departmentName": "ΦΥΣΙΚΗΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 269,
// 		"departmentName": "ΧΗΜΕΙΑΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 272,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΕΠΙΣΤΗΜΗΣ ΥΛΙΚΩΝ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 280,
// 		"departmentName": "ΒΙΟΛΟΓΙΚΩΝ ΕΦΑΡΜΟΓΩΝ ΚΑΙ ΤΕΧΝΟΛΟΓΙΩΝ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 301,
// 		"departmentName": "ΙΑΤΡΙΚΗΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 340,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΛΗΡΟΦΟΡΙΚΗΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 345,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 779,
// 		"departmentName": "ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1241,
// 		"departmentName": "ΑΓΩΓΗΣ ΚΑΙ ΦΡΟΝΤΙΔΑΣ ΣΤΗΝ ΠΡΩΙΜΗ ΠΑΙΔΙΚΗ ΗΛΙΚΙΑ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1242,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ (ΑΡΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1244,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΠΡΕΒΕΖΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1245,
// 		"departmentName": "ΛΟΓΟΘΕΡΑΠΕΙΑΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1248,
// 		"departmentName": "ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΡΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1249,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1250,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΑΡΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ",
// 		"departmentID": 1251,
// 		"departmentName": "ΨΥΧΟΛΟΓΙΑΣ (ΙΩΑΝΝΙΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 115,
// 		"departmentName": "ΦΙΛΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 116,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 132,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 138,
// 		"departmentName": "ΦΙΛΟΣΟΦΙΚΩΝ ΚΑΙ ΚΟΙΝΩΝΙΚΩΝ ΣΠΟΥΔΩΝ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 149,
// 		"departmentName": "ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 151,
// 		"departmentName": "ΨΥΧΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 158,
// 		"departmentName": "ΠΑΙΔΑΓΩΓΙΚΟ ΠΡΟΣΧΟΛΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 200,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΥΛΙΚΩΝ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 216,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΥΠΟΛΟΓΙΣΤΩΝ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 248,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ KAI ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ (ΗΡΑΚΛΕΙΟ) - ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 251,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ KAI ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ (ΗΡΑΚΛΕΙΟ) - ΜΑΘΗΜΑΤΙΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 261,
// 		"departmentName": "ΦΥΣΙΚΗΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 270,
// 		"departmentName": "ΧΗΜΕΙΑΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 282,
// 		"departmentName": "ΒΙΟΛΟΓΙΑΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 304,
// 		"departmentName": "ΙΑΤΡΙΚΗΣ (ΗΡΑΚΛΕΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 321,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 351,
// 		"departmentName": "ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΡΕΘΥΜΝΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 161,
// 		"departmentName": "ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΣΠΟΥΔΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 174,
// 		"departmentName": "ΕΚΠΑΙΔΕΥΤΙΚΗΣ ΚΑΙ ΚΟΙΝΩΝΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 176,
// 		"departmentName": "ΒΑΛΚΑΝΙΚΩΝ, ΣΛΑΒΙΚΩΝ ΚΑΙ ΑΝΑΤΟΛΙΚΩΝ ΣΠΟΥΔΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 317,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΠΑΝ. ΜΑΚΕΔ."
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 322,
// 		"departmentName": "ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 337,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 409,
// 		"departmentName": "ΜΟΥΣΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1211,
// 		"departmentName": "ΕΦΑΡΜΟΣΜΕΝΗΣ ΠΛΗΡΟΦΟΡΙΚΗΣ - ΕΠΙΣΤΗΜΗ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑ ΥΠΟΛΟΓΙΣΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ",
// 		"departmentID": 1212,
// 		"departmentName": "ΕΦΑΡΜΟΣΜΕΝΗΣ ΠΛΗΡΟΦΟΡΙΚΗΣ - ΠΛΗΡΟΦΟΡΙΑΚΑ ΣΥΣΤΗΜΑΤΑ (ΘΕΣΣΑΛΟΝΙΚΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 102,
// 		"departmentName": "ΦΙΛΟΣΟΦΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 136,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΚΑΙ ΤΗΣ ΑΓΩΓΗΣ ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΗΛΙΚΙΑ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 169,
// 		"departmentName": "ΘΕΑΤΡΙΚΩΝ ΣΠΟΥΔΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 175,
// 		"departmentName": "ΦΙΛΟΛΟΓΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 205,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΑΤΡΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 213,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΚΑΙ ΑΕΡΟΝΑΥΠΗΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 215,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΛΗΡΟΦΟΡΙΚΗΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 221,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΥΠΟΛΟΓΙΣΤΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΑΤΡΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 232,
// 		"departmentName": "ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 239,
// 		"departmentName": "ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 247,
// 		"departmentName": "ΜΑΘΗΜΑΤΙΚΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 257,
// 		"departmentName": "ΦΥΣΙΚΗΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 267,
// 		"departmentName": "ΧΗΜΕΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 281,
// 		"departmentName": "ΒΙΟΛΟΓΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 287,
// 		"departmentName": "ΓΕΩΛΟΓΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 288,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΤΩΝ ΥΛΙΚΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 293,
// 		"departmentName": "ΦΑΡΜΑΚΕΥΤΙΚΗΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 299,
// 		"departmentName": "ΙΑΤΡΙΚΗΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 319,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 352,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1272,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1273,
// 		"departmentName": "ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΑΙΓΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1274,
// 		"departmentName": "ΛΟΓΟΘΕΡΑΠΕΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1276,
// 		"departmentName": "ΖΩΙΚΗΣ ΠΑΡΑΓΩΓΗΣ, ΑΛΙΕΙΑΣ ΚΑΙ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΩΝ (ΜΕΣΟΛΟΓΓΙ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1278,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΑΓΡΙΝΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1280,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΦΥΤΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΜΕΣΟΛΟΓΓΙ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1282,
// 		"departmentName": "ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1283,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΤΟΥΡΙΣΜΟΥ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1284,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ - ΑΡΧΑΙΟΛΟΓΙΑΣ (ΑΓΡΙΝΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ",
// 		"departmentID": 1286,
// 		"departmentName": "ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΚΑΙ ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΠΑΤΡΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 98,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΤΡΙΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 104,
// 		"departmentName": "ΙΣΤΟΡΙΑΣ, ΑΡΧΑΙΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΠΟΛΙΤΙΣΜΙΚΩΝ ΑΓΑΘΩΝ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 187,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΚΟΡΙΝΘΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 189,
// 		"departmentName": "ΦΙΛΟΛΟΓΙΑΣ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 190,
// 		"departmentName": "ΝΟΣΗΛΕΥΤΙΚΗΣ (ΤΡΙΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 361,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΤΡΙΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 362,
// 		"departmentName": "ΘΕΑΤΡΙΚΩΝ ΣΠΟΥΔΩΝ (ΝΑΥΠΛΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 400,
// 		"departmentName": "ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΑΘΛΗΤΙΣΜΟΥ (ΣΠΑΡΤΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 411,
// 		"departmentName": "ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΔΙΕΘΝΩΝ ΣΧΕΣΕΩΝ (ΚΟΡΙΝΘΟΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1511,
// 		"departmentName": "ΓΕΩΠΟΝΙΑΣ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1512,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1513,
// 		"departmentName": "ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1514,
// 		"departmentName": "ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΟΡΓΑΝΙΣΜΩΝ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1515,
// 		"departmentName": "ΛΟΓΟΘΕΡΑΠΕΙΑΣ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1516,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΟΛΟΓΙΑΣ (ΚΑΛΑΜΑΤΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1517,
// 		"departmentName": "ΠΑΡΑΣΤΑΤΙΚΩΝ ΚΑΙ ΨΗΦΙΑΚΩΝ ΤΕΧΝΩΝ (ΝΑΥΠΛΙΟ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1518,
// 		"departmentName": "ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΤΡΙΠΟΛΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1519,
// 		"departmentName": "ΨΗΦΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΣΠΑΡΤΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1520,
// 		"departmentName": "ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΣΠΑΡΤΗ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1522,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΕΛ/ΝΗΣΟΥ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1523,
// 		"departmentName": "ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΕΛ/ΝΗΣΟΥ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ",
// 		"departmentID": 1524,
// 		"departmentName": "ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΕΛ/ΝΗΣΟΥ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 124,
// 		"departmentName": "ΔΗΜΟΣΙΑΣ ΔΙΟΙΚΗΣΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 125,
// 		"departmentName": "ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΙΣΤΟΡΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 126,
// 		"departmentName": "ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΠΑΝΤΕΙΟ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 152,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΗΣ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 153,
// 		"departmentName": "ΕΠΙΚΟΙΝΩΝΙΑΣ, ΜΕΣΩΝ ΚΑΙ ΠΟΛΙΤΙΣΜΟΥ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 159,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 165,
// 		"departmentName": "ΚΟΙΝΩΝΙΚΗΣ ΑΝΘΡΩΠΟΛΟΓΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 170,
// 		"departmentName": "ΨΥΧΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΠΑΝΤΕΙΟ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ",
// 		"departmentID": 179,
// 		"departmentName": "ΔΙΕΘΝΩΝ, ΕΥΡΩΠΑΪΚΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΑΤΡΙΑΡΧΙΚΗ ΑΝΩΤΑΤΗ ΕΚΚΛΗΣΙΑΣΤΙΚΗ ΑΚΑΔΗΜΙΑ ΚΡΗΤΗΣ",
// 		"departmentID": 416,
// 		"departmentName": "ΠΡΟΓΡΑΜΜΑ ΙΕΡΑΤΙΚΩΝ ΣΠΟΥΔΩΝ ΗΡΑΚΛΕΙΟΥ ΚΡΗΤΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 214,
// 		"departmentName": "ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΧΑΝΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 230,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΧΑΝΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 242,
// 		"departmentName": "ΜΗΧΑΝΙΚΩΝ ΟΡΥΚΤΩΝ ΠΟΡΩΝ (ΧΑΝΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 331,
// 		"departmentName": "ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΧΑΝΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ",
// 		"departmentID": 370,
// 		"departmentName": "ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΧΑΝΙΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΥΡΟΣΒΕΣΤΙΚΗ ΑΚΑΔΗΜΙΑ",
// 		"departmentID": 871,
// 		"departmentName": "ΑΞΙΩΜΑΤΙΚΩΝ ΠΥΡΟΣΒΕΣΤΙΚΗΣ ΑΚΑΔΗΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΠΥΡΟΣΒΕΣΤΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΥΡΟΣΒΕΣΤΙΚΗ ΑΚΑΔΗΜΙΑ",
// 		"departmentID": 876,
// 		"departmentName": "ΣΧΟΛΗ ΠΥΡΟΣΒΕΣΤΩΝ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΠΥΡΟΣΒΕΣΤΙΚΗ ΑΚΑΔΗΜΙΑ",
// 		"departmentID": 877,
// 		"departmentName": "ΑΞΙΩΜΑΤΙΚΩΝ ΠΥΡΟΣΒΕΣΤΙΚΗΣ ΑΚΑΔΗΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ",
// 		"departmentID": 831,
// 		"departmentName": "ΙΑΤΡΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ",
// 		"departmentID": 836,
// 		"departmentName": "ΟΔΟΝΤΙΑΤΡΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ",
// 		"departmentID": 841,
// 		"departmentName": "ΚΤΗΝΙΑΤΡΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ",
// 		"departmentID": 846,
// 		"departmentName": "ΦΑΡΜΑΚΕΥΤΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ",
// 		"departmentID": 866,
// 		"departmentName": "ΝΟΜΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ",
// 		"departmentID": 867,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ",
// 		"departmentID": 875,
// 		"departmentName": "ΨΥΧΟΛΟΓΩΝ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΕΥΕΛΠΙΔΩΝ",
// 		"departmentID": 801,
// 		"departmentName": "ΕΥΕΛΠΙΔΩΝ (ΣΣΕ) – ΟΠΛΑ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΕΥΕΛΠΙΔΩΝ",
// 		"departmentID": 806,
// 		"departmentName": "ΕΥΕΛΠΙΔΩΝ (ΣΣΕ) – ΣΩΜΑΤΑ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΝΟΣΗΛΕΥΤΙΚΗΣ",
// 		"departmentID": 851,
// 		"departmentName": "ΑΞΙΩΜΑΤΙΚΩΝ ΝΟΣΗΛΕΥΤΙΚΗΣ (ΣΑΝ)"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΙΚΑΡΩΝ",
// 		"departmentID": 821,
// 		"departmentName": "ΙΚΑΡΩΝ (ΣΙ) ΙΠΤΑΜΕΝΟΙ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΙΚΑΡΩΝ",
// 		"departmentID": 826,
// 		"departmentName": "ΙΚΑΡΩΝ (ΣΙ) ΜΗΧΑΝΙΚΟΙ (ΣΜΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΙΚΑΡΩΝ",
// 		"departmentID": 827,
// 		"departmentName": "ΙΚΑΡΩΝ (ΣΙ) ΕΛΕΓΚΤΕΣ ΑΕΡΑΜΥΝΑΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΙΚΑΡΩΝ",
// 		"departmentID": 884,
// 		"departmentName": "ΙΚΑΡΩΝ (ΣΙ) ΜΕΤΕΩΡΟΛΟΓΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΙΚΑΡΩΝ",
// 		"departmentID": 885,
// 		"departmentName": "ΙΚΑΡΩΝ (ΣΙ) ΕΡΕΥΝΑΣ ΠΛΗΡΟΦΟΡΙΚΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΙΚΑΡΩΝ",
// 		"departmentID": 886,
// 		"departmentName": "ΙΚΑΡΩΝ (ΣΙ) ΔΙΟΙΚΗΤΙΚΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΙΚΑΡΩΝ",
// 		"departmentID": 887,
// 		"departmentName": "ΙΚΑΡΩΝ (ΣΙ) ΕΦΟΔΙΑΣΤΩΝ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ NAYTIKOY",
// 		"departmentID": 864,
// 		"departmentName": "ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΝΑΥΤΙΚΟΥ (Σ.Μ.Υ.Ν.)"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ",
// 		"departmentID": 878,
// 		"departmentName": "ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ (ΣΜΥΑ) - ΚΑΤΕΥΘΥΝΣΗ ΤΕΧΝΟΛΟΓΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ",
// 		"departmentID": 879,
// 		"departmentName": "ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ (ΣΜΥΑ) - ΚΑΤΕΥΘΥΝΣΗ ΕΠΙΧΕΙΡΗΣΙΑΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ",
// 		"departmentID": 880,
// 		"departmentName": "ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ (ΣΜΥΑ) - ΚΑΤΕΥΘΥΝΣΗ ΔΙΟΙΚΗΤΙΚΗΣ ΚΑΙ ΕΦΟΔΙΑΣΤΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ ΞΗΡΑΣ",
// 		"departmentID": 862,
// 		"departmentName": "ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ (Σ.Μ.Υ.) – ΟΠΛΑ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ ΞΗΡΑΣ",
// 		"departmentID": 863,
// 		"departmentName": "ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ (Σ.Μ.Υ.) – ΣΩΜΑΤΑ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ",
// 		"departmentID": 811,
// 		"departmentName": "ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ (ΣΝΔ) ΜΑΧΙΜΟΙ"
// 	},
// 	{
// 		"departmentInstitution": "ΣΧΟΛΗ ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ",
// 		"departmentID": 816,
// 		"departmentName": "ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ (ΣΝΔ) ΜΗΧΑΝΙΚΟΙ"
// 	},
// 	{
// 		"departmentInstitution": "ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 144,
// 		"departmentName": "ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΒΙΩΣΙΜΗΣ ΑΝΑΠΤΥΞΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 294,
// 		"departmentName": "ΕΠΙΣΤΗΜΗΣ ΔΙΑΙΤΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΤΡΟΦΗΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 356,
// 		"departmentName": "ΓΕΩΓΡΑΦΙΑΣ (ΑΘΗΝΑ)"
// 	},
// 	{
// 		"departmentInstitution": "ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ",
// 		"departmentID": 412,
// 		"departmentName": "ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΜΑΤΙΚΗΣ (ΑΘΗΝΑ)"
// 	}
// ]
    axios
      .get(
        `${config.BASE_URL}/greekInstitutions`
      )
      .then(response => {
        this.allDepartments = response.data.data
		    // console.log('this.allDepartment', this.allDepartments)
        // this.$emit(
        //   'greekUniversityDepartments',
        //    this.allDepartments
        // )
        // // this.$emit('greekTeiDepartments', this.greekTeiDepartments)
      })
      .catch(err => {
        this.backendErrorNotify(err)
      })
  },
  components: {
    PersonalDetails,
    Titles,
    HistoryLine,
    TitleConsideration,
    AttachedDocuments,
  },
  props: [
    'application',
    'externalUserId',
    'fetchingNewApp',
    'countries',
    'neededDocsGr',
    'neededDocsEn',
    'neededDocsIds',
    'neededDocsInformation',
    'neededDocsInformationGr',
    'neededDocsInformationEng',
    'neededDocsMandatory',
  ],
  mixins: [sharedMethods],
  data() {
    return {
      stagingEnv: config.STAGING_ENV,
      forceOverdue: false,
      beforeFirstSave: false,
      isOverdue: false,
      minimizedGreekDepts: [],
      allDepartments: [],
      localHistory: [{ content: 'Αναμονή κατάστασης' }],
      precheckerCommentForUser: '',
      direction: 'horizontal',
      greekTeiDepartments: [],
      greekUniversityDepartments: [],
      externalUser: {},
      pilotNewEdit: 'new',
      transition: 'transition',
      consideration: 'consideration',
      correspondence: 'correspondence',
      // language: '',
      informed: false,
      applicationFinalSaved: this.application.applicationHistory
        ? this.application.applicationHistory[
            this.application.applicationHistory.length - 1
          ].applicationStatus !== 'userW_'
        : false,
      applicationTemp: {},
      usersAllApplications: JSON.parse(sessionStorage.getItem('usersAllApplications')),
      loadingApplication: false,
      historyActive: 0,
      saving: false,
      pdValid: false,
      titlesValid: false,
      considerationValid: false,
      checkFormPD: false,
      checkFormTitles: false,
      checkFormTC: false,
      mandatoryDocs: false,
    }
  },
  methods: {
    preventNav(event) {
      // if (!this.isEditing) return
      let obj = JSON.parse(sessionStorage.getItem('workingApplication'))
      this.isOverdue = obj.overdue
      this.$emit('workingApplication', obj)
      event.preventDefault()
      event.returnValue = ""
    },
    attachedDocumentsTableEvent(table) {
      this.application.attachedDocuments = table
    },
    setPreCommentForUser(pendingReason) {
      this.precheckerCommentForUser = pendingReason
    },
    mandatoryDocsM(mandatory) {
      this.mandatoryDocs = mandatory
    },
    validateAllForms() {
      if (this.application.applicationType !== 'reappraisal') {
        if (this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
          this.checkFormTC = !this.checkFormTC
        } else if (!this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (this.application.applicationType === 'reappraisal') {
        this.checkFormPD = !this.checkFormPD
      }
    },
    activateValidation() {
      if (this.application.applicationType !== 'reappraisal') {
        if (this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
          this.checkFormTC = !this.checkFormTC
        } else if (!this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (this.application.applicationType === 'reappraisal') {
        this.checkFormPD = !this.checkFormPD
      }
    },
    validateCurrentForm() {
      if (this.application.consideration && this.applicationTempSaved) {
        if (this.historyActive === 1) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 2) {
          this.checkFormTitles = !this.checkFormTitles
        }
        if (this.historyActive === 3) {
          this.checkFormTC = !this.checkFormTC
        }
      } else if (!this.application.consideration && this.applicationTempSaved) {
        if (this.historyActive === 1) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 2) {
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (
        !this.application.consideration &&
        !this.applicationTempSaved
      ) {
        if (this.historyActive === 0) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 1) {
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (this.application.consideration && !this.applicationTempSaved) {
        if (this.historyActive === 0) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 1) {
          this.checkFormTitles = !this.checkFormTitles
        }
        if (this.historyActive === 2) {
          this.checkFormTC = !this.checkFormTC
        }
      }
    },
    stepClick(e, i) {
      this.validateCurrentForm()
      this.historyActive = i
    },
    countriesEvent(countries) {
      this.countries = countries
    },
    titlesCorrespondenceChangedEvent(titles) {
      this.application.titlesCorrespondence = titles
    },
    transitionChanged(transition) {
      this.application.transition = transition === 'transition'
    },
    considerationChanged(consideration) {
      this.application.consideration = consideration === 'consideration'
    },
    correspondenceChanged(correspondence) {
      this.application.correspondence = correspondence === 'correspondence'
    },
    // considerOtherTitles () {
    //   this.$emit('consider-other-titles', this.application.consideration)
    //   this.$emit('titlesChanged', this.titles)
    // },
    // where is this function used?????
    notifyForDB() {
      this.$notify.warning({
        title: this.$t('Warning'),
        message: this.$t('msg_forDB'),
        offset: 100,
      })
    },
    retractApplication() {
      this.$confirm(this.$t('confirm_retract'), this.$t('warning'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(() => {
          this.saving = true
          axios
            .post(
              `${config.BASE_URL}/externalusers/${this.externalUserId}/applications/${this.application.id}/retraction`
            )
            .then(response => {
              this.saving = false
              this.backendSuccessMsg(response)
              this.$emit('newApplication')
              this.$router.replace('/login')
            })
            .catch(err => {
              this.saving = false
              this.backendErrorNotify(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('retract_canceled'),
          })
        })
    },
    deleteApplication() {
      this.$confirm(this.$t('confirm_delete'), this.$t('warning'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(() => {
          this.saving = true
          if (this.applicationFinalSaved) {
            alert('Cannot be deleted after Final Save')
          } else {
            axios
              .delete(
                `${config.BASE_URL}/applications/${this.application.id}`
              )
              .then(response => {
                this.saving = false
                this.backendSuccessMsg(response)
                // this.$message({
                //   type: 'success',
                //   message: this.$t("app_deleted")
                // })
                this.$emit('newApplication')
                this.$router.replace('/login')
              })
              .catch(err => {
                this.saving = false
                this.backendErrorNotify(err)
                // this.$notify.warning({
                //   title: this.$t("warning"),
                //   message: this.$t("delete_fail"),
                //   offset: 100
                // })
              })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('delete_canceled'),
          })
        })
    },
    checkAdditionalUnis() {
      if (
        this.application.titles.additionalUniversities != null &&
        this.application.titles.additionalUniversities.length > 0
      ) {
        this.application.titles.additionalUniversities = this.application.titles.additionalUniversities.filter(
          uni => uni.university !== '' && uni.university !== null
        )
        if (this.application.titles.additionalUniversities.length === 0) {
          this.application.titles.studiesInMoreUniversities = false
        }
      } else {
        this.application.titles.studiesInMoreUniversities = false
      }
      if (this.application.titles.titleConsideration) {
        if (
          this.application.titles.titleConsideration.additionalUniversities !=
            null &&
          this.application.titles.titleConsideration.additionalUniversities
            .length > 0
        ) {
          this.application.titles.titleConsideration.additionalUniversities = this.application.titles.titleConsideration.additionalUniversities.filter(
            uni => uni.university !== '' && uni.university !== null
          )
          if (
            this.application.titles.titleConsideration.additionalUniversities
              .length === 0
          ) {
            this.application.titles.titleConsideration.studiesInMoreUniversities = false
          }
        } else {
          this.application.titles.titleConsideration.studiesInMoreUniversities = false
        }
      }
    },
    finalSave() {
      this.checkAdditionalUnis()
      this.activateValidation()
      this.$nextTick(() => {
        this.validateAllForms()
        this.$nextTick(() => {
          let msg = this.$t('submitApp')
          if (this.isReappraisal && (this.isOverdue || (this.stagingEnv && this.forceOverdue))) {
            msg = this.$t('overdue_warning_final')
          }
          if (this.formsValid) {
            this.$confirm(msg, this.$t('warning'), {
              confirmButtonText: 'OK',
              cancelButtonText: this.$t('cancel'),
              type: 'warning',
              customClass: 'message-box-relative',
            })
              .then(() => {
                this.saving = true
                let appForSave = Object.assign({}, this.application)
                appForSave.correspondence = true
                // fix for compatibility with older apps
                appForSave.recognitionWith = "aeiAndTei"
                appForSave.language = this.$i18n.locale
                delete appForSave.neededDocuments
                delete appForSave.applicationHistory
                appForSave.forceOverdue = this.stagingEnv && this.forceOverdue
                axios
                  .put(
                    `${config.BASE_URL}/externalusers/${this.externalUserId}/applications/${this.application.id}/final`,
                    appForSave
                  )
                  .then(response => {
                    this.saving = false
                    this.backendSuccessMsg(response)
                    // this.$notify.success({
                    //   title: 'Ειδοποίηση',
                    //   message: this.$t("msg_finalsave"),
                    //   duration: 0,
                    //   offset: 100
                    // })
                    this.applicationFinalSaved = true
                    this.$emit('applicationFinalSavedEvent', this.application.id)
                    this.applicationTemp = this.application
                  })
                  .catch(err => {
                    this.saving = false
                    this.backendErrorNotify(err)
                  })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('finalsave_canceled'),
                })
              })
              .finally(() => {
                this.saving = false
              })
          } else {
            this.tempSave()
            this.$notify.warning({
              title: this.validationMessage.title,
              message: this.validationMessage.body,
              duration: 10000,
              offset: 100,
            })
          }
        })
      })
    },
    tempSave() {
      this.checkAdditionalUnis()
      this.saving = true
      let appForSave = Object.assign({}, this.application)
      appForSave.correspondence = true
      appForSave.language = this.$i18n.locale
      delete appForSave.neededDocuments
      delete appForSave.applicationHistory
      appForSave.forceOverdue = this.stagingEnv && this.forceOverdue
      // /fromintusers/externalusers/
      axios
        .put(
          `${config.BASE_URL}/externalusers/${this.externalUserId}/applications/${this.application.id}/temp`,
          appForSave
        )
        .then(response => {
          this.saving = false
          // this.$notify.warning({
          //   title: this.$t("warning"),
          //   message: this.$t("data_saved"),
          //   offset: 100
          // })
          this.$emit('applicationFinalSavedEvent', this.application.id)
          this.application = JSON.parse(sessionStorage.getItem('workingApplication'))
          this.applicationTemp = this.application
          this.backendSuccessMsg(response)
        })
        .catch(err => {
          this.saving = false
          this.backendErrorNotify(err)
        })
    },
    degreeLevelChanged(degree) {
      if (degree === 'master' || degree === 'phd') {
        this.application.consideration = false
        this.consideration = 'noConsideration'
        this.correspondence = 'equality'
        this.application.correspondence = false
      } else {
        this.application.consideration = true
        this.consideration = 'consideration'
        this.correspondence = 'correspondence'
        this.application.correspondence = true
      }
    },
    pdValidEvent(pdValid) {
      this.pdValid = pdValid
    },
    titlesValidEvent(titlesValid) {
      this.titlesValid = titlesValid
    },
    considerationValidEvent(considerationValid) {
      this.considerationValid = considerationValid
    },
    documentsChangedEvent(attachedDocuments) {
      this.application.attachedDocuments = attachedDocuments.map(doc => {
        return {
          id: doc.id,
          applicantComment: doc.applicantComment,
          type: doc.type,
          date: doc.date,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          name: doc.name,
        }
      })
    },
    generalCommentChangedEvent(generalComment) {
      this.application.userComment = generalComment
    },
    considerOtherTitlesEvent(consider) {
      this.application.consideration = consider
    },
    personalDetailsEvent(personalDetails) {
      this.application.personalDetails = personalDetails
    },
    titlesChangedEvent(titles) {
      this.application.titles = titles
    },
    titleConsiderationEvent(titleConsideration) {
      this.application.titles.titleConsideration = titleConsideration
    },
    nextHistoryStep() {
      // this.validateCurrentForm()
      this.historyActive >= this.historySteps - 1
        ? (this.historyActive = 0)
        : this.historyActive++
    },
    previousHistoryStep() {
      // this.validateCurrentForm()
      this.historyActive < 1
        ? (this.historyActive = this.historySteps - 1)
        : this.historyActive--
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    inDays(d1, d2) {
      // let t2 = d2.getTime()
      // let t1 = d1.getTime()
      return Math.abs(d2 - d1)
      // dateStr.replace(/-/g,'/')
      // return parseInt((d2 - d1) / (24 * 3600 * 1000))
    },
  },
  computed: {
    inPrecheckersQueue () {
      return this.application.applicationHistory[
              this.application.applicationHistory.length - 1
            ].applicationStatus === 'precheckersQueue'
    },
    language () {
      return this.$i18n.locale
    },
    calcApplicationState() {
      this.$notify.info({
        title: this.$t('app_status1'),
        message: this.localHistory[this.localHistory.length - 1].content,
        offset: 100,
      })
      const lastState =  this.application.applicationHistory[
          this.application.applicationHistory.length - 1
        ].applicationStatus
      if (lastState === 'deactivated') {
        return this.$i18n.t('completed1')
      } else if (this.finalized) {
        return this.$i18n.t('completed2')
      } else if (
        this.application.protocol &&
        this.application.protocol !== null &&
        this.application.protocol !== ''
      ) {
        let registered_text = this.$i18n.t('registered_app')
        if (this.isReappraisal) {
          registered_text = this.$i18n.t('registered_reapp')
        }
        if (this.isPostExam) {
          registered_text = this.$i18n.t('registered_post_exam')
        }
        return registered_text
      } else if (this.application.applicationHistory.length > 1 && lastState !== 'userW_') {
        return this.$i18n.t('final_saved')
      } else {
        return this.$i18n.t('temp_saved')
      }
    },
    calcProtocol() {
      if (
        this.application.protocol &&
        this.application.protocol !== null &&
        this.application.protocol !== ''
      ) {
        const newForm = this.formatProtocol({ protocol: this.application.protocol })
        return newForm
      } else {
        return this.$t('protocol_expected')
      }
    },
    calcRelevantProtocol() {
      const newForm = this.formatProtocol({
        number: this.application.relevantAppl.protocol,
        date: this.application.relevantAppl.protocol_date
      })
      return newForm
    },
    postExamRelevantAppText() {
      if (!this.isPostExam) {
        return '---'
      }
      const appType = this.application.relevantAppl.specialFields.applicationType
      if (appType === 'reappraisal') {
        return this.$i18n.t('post_exam_reapp_app')
      }
      return this.$i18n.t('reappraisal_app')
    },
    actApprove() {
      return this.application.attachedDocuments.find(doc => doc.type === 22) &&
        this.application.attachedDocuments.find(doc => doc.type === 22)
          .actApproval
        ? this.application.attachedDocuments.find(doc => doc.type === 22)
            .actApproval
        : { approved: null, dateApproved: null, comment: null }
    },
    praksiDownloadedFromUser() {
      const lastState = this.application.applicationHistory[
          this.application.applicationHistory.length - 1
        ]
      if (lastState.applicationStatus === 'president_finalized') {
        let dateComple = lastState.dateCompleted
        let dateNow = new Date()
        if (dateComple !== null) {
          dateComple = new Date(dateComple.replace(/-/g, '/'))
          let diff = 10 - Math.floor(0.5 + (dateNow - dateComple) / 86400000)
          return diff // μερες που απομενουν
        } else {
          return -100 // ο χρήστης δεν έχει κατεβάσει ακόμα το αρχείο
        }
      } else {
        return -1 // δεν εχει φτάσει το τελευταιο βήμα η αίτηση
      }
    },
    dateDone() {
      return this.application.applicationHistory[
        this.application.applicationHistory.length - 1
      ].dateGR
    },
    dateReceived() {
      return this.application.applicationHistory[
        this.application.applicationHistory.length - 1
      ].dateCompletedGR
    },
    dateDownloaded() {
      const allRecognitions = this.application.attachedDocuments
          .filter(doc => decisionReceiptDocs.includes(doc.type)) || null

      if (allRecognitions && allRecognitions.length > 0) {
        if (allRecognitions.at(-1).downloadedByUserAtGR) {
          return allRecognitions.at(-1).downloadedByUserAtGR
        } else {
          console.log('Δεν υπάρχει βεβαίωση παραλαβής της τελευταίας πράξης.')
        }
      }
      return '-'
    },
    finalized() {
      const lastState = this.application.applicationHistory[
        this.application.applicationHistory.length - 1
      ]
      return lastState.applicationStatus === 'president_finalized' &&
        lastState.dateCompleted !== null
    },
    formsValid() {
      if (!this.isReappraisal && !this.isPostExam) {
        if (this.application.consideration) {
          return this.titlesValid && this.pdValid && this.considerationValid && this.mandatoryDocs
        } else if (!this.application.consideration) {
          return this.titlesValid && this.pdValid && this.mandatoryDocs
        // if (this.application.consideration) {
        //   return this.titlesValid && this.pdValid && this.considerationValid && this.mandatoryDocs
        // } else if (!this.application.consideration) {
        //   return this.titlesValid && this.pdValid && this.mandatoryDocs
        }
      } else if (this.isReappraisal || this.isPostExam) {
          return this.pdValid && this.mandatoryDocs
        } 
    },
    validationMessage() {
      let valMessage = { title: '', body: '' }
      if (!this.formsValid) {
        valMessage.title = this.$t('failed_submit')
        valMessage.body = this.$t('failed_submit2')
        if (!this.isReappraisal && !this.isPostExam) {
          if (this.application.consideration) {
            if (this.pdValid === false)
              valMessage.body += this.$t('failed_submit3')
            if (this.titlesValid === false)
              valMessage.body += this.$t('failed_submit4')
            if (this.considerationValid === false)
              valMessage.body += this.$t('failed_submit5')
            if (this.mandatoryDocs === false)
              valMessage.body += this.$t('failed_submit6')
          } else if (!this.application.consideration) {
            if (this.pdValid === false)
              valMessage.body += this.$t('failed_submit3')
            if (this.titlesValid === false)
              valMessage.body += this.$t('failed_submit4')
            if (this.mandatoryDocs === false)
              valMessage.body += this.$t('failed_submit6')
          }
        } else if (this.isReappraisal || this.isPostExam) {
          if (this.pdValid === false)
              valMessage.body += this.$t('failed_submit3')
          if (this.mandatoryDocs === false)
              valMessage.body += this.$t('failed_submit6')
        }
        valMessage.body = valMessage.body.slice(0, -1) + '.'
        return valMessage
      }
    },
    loadingApplications() {
      return this.fetchingNewApp
    },
    history() {
      let calcHistoryLine = []
      this.setPreCommentForUser('')
      if (this.application.applicationHistory) {
        let groupTemp = 0
        let titleTemp = ''
        let contentTemp = ''
        // let endTemp = ''
        let historySteps = this.application.applicationHistory.slice(0)
        for (let step = 0; step < historySteps.length; step++) {
          switch (historySteps[step].applicationStatus) {
            case 'userW_':
              groupTemp = 0
              titleTemp = this.$t('titleTemp0')
              // titleTemp = `<div>Ο χρήστης ετοιμάζει την αίτηση του πριν</div>
              //               <div>την υποβάλει οριστικά για επεξεργασία</div>`
              contentTemp = this.$t('contentTemp0')
              break
            case 'precheckersQueue':
              groupTemp = 1
              titleTemp = this.$t('titleTemp1')
              contentTemp = this.$t('contentTemp1')
              break
            case 'precheckerW_':
              groupTemp = 2
              if (historySteps[step].judgment.pending) {
                this.setPreCommentForUser(
                  historySteps[step].judgment.pendingReason
                )
              }
              titleTemp = historySteps[step].judgment.pending
                ? `<h4>${this.$t('titleTemp22')}</h4>
                  <div>
                    ${
                      historySteps[step].judgment.pendingReason != null
                        ? historySteps[step].judgment.pendingReason
                        : ''
                    }
                  </div>${this.$t('titleTemp2')}`
                : this.$t('titleTemp21')
              contentTemp = this.$t('contentTemp2')
              break
            case 'precheckerCompensatoryW_':
              groupTemp = 2
              titleTemp = this.$t('titleTemp2postExam')
              contentTemp = this.$t('contentTemp2postExam')
              break
            case 'presidentW_Prechecker':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp3')}</div>`
              contentTemp = this.$t('titleTemp3')
              break
            case 'proponentW_President':
              groupTemp = 4
              titleTemp =
                historySteps[step].judgment &&
                historySteps[step].judgment.pendingReason
                  ? `<h4>${this.$t('titleTemp4')}</h4>
                  <div>
                    ${
                      historySteps[step].judgment.pendingReason != null
                        ? historySteps[step].judgment.pendingReason
                        : ''
                    }
                  </div>${this.$t('titleTemp2')}`
                  : this.$t('titleTemp41')
              // titleTemp = `<div>Επεξεργασία από τον Χειριστή</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'proponentW_Prechecker':
              groupTemp = 4
              titleTemp =
                historySteps[step].judgment &&
                historySteps[step].judgment.pendingReason
                  ? `<h4>${this.$t('titleTemp4')}</h4>
                  <div>
                    ${
                      historySteps[step].judgment.pendingReason != null
                        ? historySteps[step].judgment.pendingReason
                        : ''
                    }
                  </div>${this.$t('titleTemp2')}`
                  : this.$t('titleTemp41')
              // titleTemp = `<div>Επεξεργασία από τον Χειριστή</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'boardW_Proponent':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'boardW_Vice':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'boardW_President':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'proponentW_Board':
              groupTemp = 4
              titleTemp = `<div>${this.$t('titleTemp41')}</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'proponentW_Admin':
              groupTemp = 4
              titleTemp = `<div>${this.$t('titleTemp41')}</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'consultantW_Proponent':
              groupTemp = 6
              titleTemp = `<div>${this.$t('titleTemp6')}</div>`
              contentTemp = this.$t('titleTemp6')
              break
            case 'consultantW_President':
              groupTemp = 6
              titleTemp = `<div>${this.$t('titleTemp6')}</div>`
              contentTemp = this.$t('titleTemp6')
              break
            case 'boardW_Consultant':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'viewerW_Board':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'presidentW_Viewer':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp33')}</div>`
              contentTemp = this.$t('titleTemp33')
              break
            case 'presidentW_Consultant':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp33')}</div>`
              contentTemp = this.$t('titleTemp33')
              break
            case 'viceW_President':
              groupTemp = 7
              titleTemp = `<div>${this.$t('titleTemp7')}</div>`
              contentTemp = this.$t('titleTemp7')
              break
            case 'viceW_Prechecker':
              groupTemp = 7
              titleTemp = `<div>${this.$t('titleTemp7')}</div>`
              contentTemp = this.$t('titleTemp7')
              break
            case 'viewerW_Vice':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'viewerW_Proponent':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'viewerW_President':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'printDecisionW_President':
              groupTemp = 10
              titleTemp = `<div>${this.$t('historyTitlePrintDecisionsQueue')}</div>`
              contentTemp = this.$t('historyContentPrintDecisionsQueue')
              break
            case 'printDecisionW_':
              groupTemp = 10
              titleTemp = `<div>${this.$t('historyTitlePrintDecision')}</div>`
              contentTemp = this.$t('historyContentPrintDecision')
              break
            case 'presidentW_PrintDecision':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp32')}</div>`
              contentTemp = this.$t('titleTemp32')
              break
            case 'president_finalized':
              groupTemp = 3
              titleTemp = this.$t('titleTemp34')
              contentTemp =
                historySteps[step].dateCompleted !== null
                  ? this.$t('contentTemp34')
                  : this.$t('contentTemp34')
              break
            // case 'reappraisalBoardW_Vice' :
            //   groupTemp = 11
            //   titleTemp = `<div>${this.$t('titleTemp11')}</div>`
            //   contentTemp = this.$t('titleTemp11')
            //   break
            case 'reappraisalBoardW_President' :
              groupTemp = 11
              titleTemp = `<div>${this.$t('titleTemp11')}</div>`
              contentTemp = this.$t('titleTemp11')
              break
            case 'proponentW_ReappraisalBoard' :
              groupTemp = 4
              titleTemp = `<div>${this.$t('titleTemp41')}</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'academicDirectorW_Proponent' :
              groupTemp = 12
              titleTemp = `<div>${this.$t('titleTemp12')}</div>`
              contentTemp = this.$t('titleTemp12')
              break
            case 'academicDirectorW_ReappraisalBoard' :
              groupTemp = 12
              titleTemp = `<div>${this.$t('titleTemp12')}</div>`
              contentTemp = this.$t('titleTemp12')
              break
            case 'presidentW_AcademicDirector_Reappraisal' :
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp33')}</div>`
              contentTemp = this.$t('titleTemp33')
              break
          }
          let d = historySteps[step].date
          // console.log(Date.parse(d.replace(/ /g,"T")))
          // console.log(typeof Date.parse(d.replace(/ /g,"T")))
          calcHistoryLine.push({
            id: historySteps[step].id,
            type: 'range',
            group: groupTemp, // null = 0
            content: contentTemp,
            start: Date.parse(historySteps[step].date),
            end:
              historySteps[step].dateCompleted !== null
                ? Date.parse(historySteps[step].dateCompleted)
                : Date.now(), // Date.now(),
            title: titleTemp,
          })
        }

        const allRecognitions = this.application.attachedDocuments
          .filter(doc => decisionReceiptDocs.includes(doc.type)) || null

        if (allRecognitions && allRecognitions.length > 0) {
          if (allRecognitions.at(-1).downloadedByUserAt) {
            calcHistoryLine.push({
              id: 'doc:' + allRecognitions.at(-1).id,
              group: 0,
              title: this.$t('historyTitleDownloaded'),
              start: allRecognitions.at(-1).downloadedByUserAt,
              content: this.$t('historyContentDownloaded')
            })
          } else {
            console.log('Δεν υπάρχει βεβαίωση παραλαβής της τελευταίας πράξης.')
          }
        }
      }
      return calcHistoryLine // new DataSet(calcHistoryLine)
    },
    conclusion() {
      let con = ''
      if (this.application.applicationType === 'recognition') {
        con = 'υποβάλετε Αίτηση Αναγνώρισης, '
        if (this.application.degreeType === 'bachelor') {
          con += 'για τίτλο 1ου κύκλου σπουδών,'
          if (this.application.correspondence) {
            con += ' με ακαδημαϊκή ισοδυναμία'
          } 
          // else {
          //   con +=
          //     ' απλής ισοτιμίας (χωρίς αντιστοίχιση τίτλου σε συγκεκριμένο Ελληνικό ιδρύμα)'
          // }
          // if (this.application.recognitionWith === 'aeiAndTei') {
          //   con += ' με Πανεπιστήμιο KAI ΤΕΙ'
          // } else if (this.application.recognitionWith === 'aei') {
          //   con += ' MONO με Πανεπιστήμιο'
          // } else if (this.application.recognitionWith === 'tei') {
          //   con += ' MONO με ΤΕΙ'
          // }
          // if (this.application.consideration) {
          //   con += ' δίνοντας επιπλέον τίτλο για συνεκτίμηση'
          // } else {
          //   con += ' ΧΩΡΙΣ επιπλέον τίτλο για συνεκτίμηση'
          // }
        } else if (this.application.degreeType === 'master') {
          con += 'για τίτλο 2ου κύκλου σπουδών'
          // if (this.application.scoreMatch) {
          //   con += ' με Βαθμολογική Αντιστοίχιση'
          // } else {
          //   con += ' χωρίς Βαθμολογική Αντιστοίχιση'
          // }
        } else if (this.application.degreeType === 'phd') {
          con += 'για τίτλο 3ου κύκλου σπουδών'
        }
      }
      return con
    },
    isBachelor() {
      return this.application.degreeType === 'bachelor'
    },
    isReappraisal() {
      return this.application.applicationType === 'reappraisal'
    },
    isPostExam() {
      return this.application.applicationType === 'compensatory'
    },
     isSecondReappraisal () {
      return this.application.reappraisalSecondDegree
    },
    applicationChanged() {
      return this.application !== this.applicationTemp
    },
    // τι νόημα έχει το applicationReady αφού πάντα είναι true όπως δηλώνεται εδώ???
    // applicationReady() {
    //   return true
    // },
    applicationTempSaved() {
      return !!(
        this.isPostExam || (this.application.id && this.application.applicationHistory.length > 1)
      )
    },
    applicationSteps() {
      if (!this.isReappraisal && !this.isPostExam) {
      let steps = [
        {
          stepNumber: 0,
          action: this.$t('process'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-search',
          details: 'axcdrefvevver',
        },
        {
          stepNumber: 1,
          action: this.$t('personal_data'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-info',
          details: 'rwfvraxcdrefvevver',
        },
        {
          stepNumber: 2,
          action: this.$t('title_study'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-edit',
          details: 'axfdvdfvcdrefvevver',
        },
        {
          stepNumber: 3,
          action: this.$t('coevaluation'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-edit-outline',
          details: 'axcdredfvdffvevver',
        },
        {
          stepNumber: 4,
          action: this.$t('attachments'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-upload',
          details: 'axcdrefvevvedfvdfvr',
        },
      ]
      if (this.application.consideration && this.applicationTempSaved) {
        return steps
      } else if (!this.application.consideration && this.applicationTempSaved) {
        // steps.splice(3, 1)
        // let newSteps = steps.map(step => step.stepNumber = stepNumber++)
        return [
          {
            stepNumber: 0,
            action: this.$t('process'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-search',
            details: 'axcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('title_study'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit',
            details: 'axfdvdfvcdrefvevver',
          },
          {
            stepNumber: 3,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          },
        ]
      } else if (
        !this.application.consideration &&
        !this.applicationTempSaved
      ) {
        // steps.splice(0, 1)
        // steps.splice(2, 1)
        return [
          {
            stepNumber: 0,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('title_study'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit',
            details: 'axfdvdfvcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          },
        ]
      } else if (this.application.consideration && !this.applicationTempSaved) {
        // steps.splice(0, 1)
        return [
          {
            stepNumber: 0,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('title_study'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit',
            details: 'axfdvdfvcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('coevaluation'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit-outline',
            details: 'axcdredfvdffvevver',
          },
          {
            stepNumber: 3,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          },
        ]
      }
      } else if (this.isReappraisal || this.isPostExam) {
        if (this.applicationTempSaved) {
        return [
          {
            stepNumber: 0,
            action: this.$t('process'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-search',
            details: 'axcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          }
        ]
        } else if (!this.applicationTempSaved) {
           return [
          {
            stepNumber: 0,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          }
        ]
        }
      }
    },
    attachedDocumentsTable() {
      let table = []
      if (this.application.attachedDocuments) {
        this.application.attachedDocuments.slice(0).forEach(doc => {
          table.push({
            type: doc.type,
            typeGr: this.neededDocsGr[this.neededDocsIds.indexOf(doc.type)],
            typeEn: this.neededDocsEn[this.neededDocsIds.indexOf(doc.type)],
            name: doc.name,
            date: doc.date,
            applicantComment: doc.applicantComment,
            id: doc.id,
            precheckerChecked: doc.precheckerChecked,
            precheckerComment: doc.precheckerComment,
            downloadedByUserAt: doc.downloadedByUserAt
          })
        })
      }
      sessionStorage.setItem('attachedDocumentsTable', JSON.stringify(table))
      return table
    },
    historySteps() {
      return this.applicationSteps.length
    },
  },
  watch: {
    history: {
      handler: function(newData) {
        this.localHistory = newData
      },
      deep: true,
    },
    application: {
      handler: function(newData, oldData) {
        sessionStorage.setItem('workingApplication', JSON.stringify(newData))
        if (newData.id !== oldData.id) {
          this.historyActive = 0
        }
        this.applicationFinalSaved = this.application.applicationHistory
          ? this.application.applicationHistory[
              this.application.applicationHistory.length - 1
            ].applicationStatus !== 'userW_'
          : false
        // beforeFirstSave set
        const history = this.application.applicationHistory
        if (history) {
          if (history.length <= 1) {
            this.beforeFirstSave = true
          } else {
            this.beforeFirstSave = history[history.length - 2].user.id === null
          }
        } else {
          this.beforeFirstSave = false
        }
        if (this.stagingEnv && this.application.applicationType === 'reappraisal' && !this.applicationFinalSaved && this.beforeFirstSave) {
          this.forceOverdue = newData.overdue
        } else {
          this.forceOverdue = false
        }
        this.isOverdue = this.application.overdue
      },
      deep: true,
    },
    // formsValid: function () {
    // }
  },
}
</script>

<style lang="scss">
@import '../styles/variables.scss';
div.el-message-box.message-box-relative {
  width: 90%;
}
@media only screen and (max-width: $screen-sm-min) {
  .minifySteps {
    display: none;
  }
   div.el-message-box {
    width: 50%;
  }
}
@media only screen and (min-width: $screen-sm-min) {
  .maxSteps {
    display: none;
  }
  div.el-message-box.message-box-relative {
    width: 50%;
  }
}

.appStatus {
  border-radius: 5px 20px;
  border: 2px solid #7fa3bb;
  padding: 5px;
  margin: 5px;
}
.el-card .box-card .user-apply-header {
  &.el-card__header {
    border-bottom: 0px;
  }
}
.el-card__header {
  border-bottom: 0px;
}
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #8595be;
  cursor: not-allowed;
}
.el-radio__input.is-disabled + span.el-radio__label {
  color: #8595be;
  cursor: not-allowed;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #8595be;
  cursor: not-allowed;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
/*button.el-button {*/
/*border-radius: 15px 30px;*/
/*border: 2px solid #7fa3bb;*/
/*}*/
// .big {
//   > .el-input {
//     width: 300px
//   }
// }
.el-dialog {
  border-radius: 25px;
  /*> .el-dialog--center {*/
  /*margin-top: 1vh;*/
  /*}*/
}
.el-row {
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 178px;
}
.el-steps {
  border-radius: 5px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 5px;
}
</style>
